import React from 'react'

import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import { useTasksTypesList } from './hooks'
import { Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { TaskType } from './types'
import {
  disableTaskType,
  disableTaskTypeMounted,
  tasksTypesListMounted,
} from './model'
import { TasksTypesNames } from '../../consts'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const ChangeTaskModal: React.FC<Props> = ({ isVisible, onClose }) => {
  const { tasksTypes, loading } = useTasksTypesList()

  disableTaskType.doneData.watch((result) => {
    if (result) {
      tasksTypesListMounted()
    }
  })

  const columns: ColumnsType<TaskType> = [
    {
      title: 'Task type',
      dataIndex: 'taskType',
      render: (item: string) =>
        TasksTypesNames[item as keyof typeof TasksTypesNames],
    },
    {
      title: '',
      fixed: 'right',
      render: (item: TaskType) => {
        if (item.disabledAt) {
          return
        }

        return (
          <div className="d-flex flex-column gap-1">
            <CButton
              color="danger"
              size="sm"
              onClick={() => {
                if (window.confirm('Are you sure?')) {
                  disableTaskTypeMounted({ id: item.taskType })
                }
              }}
            >
              Disable
            </CButton>
          </div>
        )
      },
    },
  ]

  return (
    <>
      <CModal visible={isVisible} onClose={onClose}>
        <CModalHeader>
          <CModalTitle>Types of tasks</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Table
            dataSource={tasksTypes}
            bordered={true}
            scroll={{ x: true }}
            loading={loading}
            rowKey="changeTaskModalId"
            columns={columns}
            pagination={false}
          />
        </CModalBody>
      </CModal>
    </>
  )
}
